import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  EventEmitter,
  Output,
} from '@angular/core';
import { addQuarters, setMonth, setDate } from 'date-fns';
import { DateRangeComponent } from './date-range.component';
import { AdDateRangeModel } from './ad-date-range-model';
import { Subscription } from 'rxjs';
import { DateRangeTypeEnum } from './date-range-type.enum';

@Component({
  selector: 'date-range-toolbar',
  templateUrl: './date-range-toolbar.component.html',
})
export class DateRangeToolbarComponent implements OnInit, OnDestroy {
  @Input() valueSetter: any;
  @Output() onSelectChange: EventEmitter<any> = new EventEmitter();
  tempRangeDates: AdDateRangeModel = new AdDateRangeModel(); //control the available state of the ok button for the daterange widget
  @Input() dateRange: DateRangeComponent;
  onDateRangeSubscription: Subscription;
  onDayClickSubscription: Subscription;
  dateRangeType = DateRangeTypeEnum;
  _itd: DateRangeTypeEnum = DateRangeTypeEnum.itd;
  @Input() set type(value) {
    this._itd = value;
    this.onSelectChange.emit({
      type: this.type,
      dateRange: {
        start: this.tempRangeDates.startDate,
        end: this.tempRangeDates.endDate,
      },
    });
  }
  get type() {
    return this._itd;
  }
  constructor() {}
  ngOnDestroy(): void {
    this.onDateRangeSubscription.unsubscribe();
    this.onSelectChange.unsubscribe();
    this.onDayClickSubscription.unsubscribe();
  }

  ngOnInit() {
    this.onDateRangeSubscription = this.dateRange.onDateRangeClick.subscribe(
      (e) => {
        this.onDateRangeClick(e);
      }
    );

    this.onDayClickSubscription = this.dateRange.onDayClicked.subscribe((e) => {
      this.onDayClick(e);
    });
  }

  onDateRangeClick(event) {
    if (event.actionName === 'clear') {
      this.clearTempRangeDates();
    } else if (event.actionName === 'end') {
      this.tempRangeDates.startDate = event.startDate;
      this.tempRangeDates.endDate = event.endDate;
    }
    this.onSelectChange.emit({
      type: this.type,
      dateRange: {
        start: this.tempRangeDates.startDate,
        end: this.tempRangeDates.endDate,
      },
    });
  }
  clearTempRangeDates() {
    this.tempRangeDates.startDate = null;
    this.tempRangeDates.endDate = null;
  }

  onDayClick(event: any) {
    this.type = DateRangeTypeEnum.custom;
  }
  changeDateRange(e: Event, condition: DateRangeTypeEnum) {
    var dates;
    switch (condition) {
      case DateRangeTypeEnum.q1:
        dates = {
          startDate: addQuarters(Date.now(), -1),
          endDate: new Date(),
        };
        break;
      case DateRangeTypeEnum.q2:
        dates = {
          startDate: addQuarters(Date.now(), -2),
          endDate: new Date(),
        };
        break;
      case DateRangeTypeEnum.q3:
        dates = {
          startDate: addQuarters(Date.now(), -3),
          endDate: new Date(),
        };
        break;
      case DateRangeTypeEnum.q4:
        dates = {
          startDate: addQuarters(Date.now(), -4),
          endDate: new Date(),
        };
        break;

      case DateRangeTypeEnum.ytd:
        dates = {
          startDate: new Date(new Date().getFullYear(), 0, 1),
          endDate: new Date(),
        };
        break;
      case DateRangeTypeEnum.custom:
        this.clearTempRangeDates();
        dates = {
          startDate: null,
          endDate: null,
        };
        break;
      case DateRangeTypeEnum.itd:
      default:
        dates = {
          type: DateRangeTypeEnum.itd,
          startDate: new Date(2000, 0 ,1),
          endDate: new Date(),
        };
        break;
    }
    this.valueSetter(dates, false);
    this.type = condition;
  }
}
